import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import { useState } from 'react';
import { isValidNumberInputKey } from '@/utils/numbers';
import Button from '@/components/Button';
import Tooltip from '@/components/Tooltip';
import TabList, { TabItem } from '@/components/navigation/TabList';
import { Label, Input } from '@/components/FormElements';
import RevealPill from '@/components/Editor/Form/fields/RevealPill';
import ScaleMinMaxFields from '@/components/Editor/Form/fields/ScaleMinMaxFields';
import parentStyles from '@/features/WidgetEdit/Form/styles.module.scss';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var FullScreenIcon = function FullScreenIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M4 10C4.55229 10 5 9.55229 5 9V8.8C5 7.94342 5.00078 7.36113 5.03755 6.91104C5.07337 6.47262 5.1383 6.24842 5.21799 6.09202C5.40973 5.7157 5.7157 5.40973 6.09202 5.21799C6.24842 5.1383 6.47262 5.07337 6.91104 5.03755C7.36113 5.00078 7.94342 5 8.8 5H9C9.55229 5 10 4.55229 10 4C10 3.44772 9.55229 3 9 3H8.7587C7.95375 2.99999 7.28936 2.99998 6.74818 3.04419C6.18608 3.09012 5.66937 3.18868 5.18404 3.43598C4.43139 3.81947 3.81947 4.43139 3.43598 5.18404C3.18868 5.66937 3.09012 6.18608 3.04419 6.74817C2.99998 7.28937 2.99999 7.95372 3 8.75869V9C3 9.55229 3.44772 10 4 10Z",
      fill: "#252833"
    }), /*#__PURE__*/_jsx("path", {
      d: "M5 15C5 14.4477 4.55229 14 4 14C3.44772 14 3 14.4477 3 15V15.2413C2.99999 16.0463 2.99998 16.7106 3.04419 17.2518C3.09012 17.8139 3.18868 18.3306 3.43598 18.816C3.81947 19.5686 4.43139 20.1805 5.18404 20.564C5.66937 20.8113 6.18608 20.9099 6.74818 20.9558C7.28937 21 7.95373 21 8.7587 21H9C9.55229 21 10 20.5523 10 20C10 19.4477 9.55229 19 9 19H8.8C7.94342 19 7.36113 18.9992 6.91104 18.9624C6.47262 18.9266 6.24842 18.8617 6.09202 18.782C5.7157 18.5903 5.40973 18.2843 5.21799 17.908C5.1383 17.7516 5.07337 17.5274 5.03755 17.089C5.00078 16.6389 5 16.0566 5 15.2V15Z",
      fill: "#252833"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19 15C19 14.4477 19.4477 14 20 14C20.5523 14 21 14.4477 21 15V15.2413C21 16.0462 21 16.7107 20.9558 17.2518C20.9099 17.8139 20.8113 18.3306 20.564 18.816C20.1805 19.5686 19.5686 20.1805 18.816 20.564C18.3306 20.8113 17.8139 20.9099 17.2518 20.9558C16.7106 21 16.0463 21 15.2413 21H15C14.4477 21 14 20.5523 14 20C14 19.4477 14.4477 19 15 19H15.2C16.0566 19 16.6389 18.9992 17.089 18.9624C17.5274 18.9266 17.7516 18.8617 17.908 18.782C18.2843 18.5903 18.5903 18.2843 18.782 17.908C18.8617 17.7516 18.9266 17.5274 18.9624 17.089C18.9992 16.6389 19 16.0566 19 15.2V15Z",
      fill: "#252833"
    }), /*#__PURE__*/_jsx("path", {
      d: "M19 9C19 9.55229 19.4477 10 20 10C20.5523 10 21 9.55229 21 9V8.7587C21 7.95378 21 7.28935 20.9558 6.74817C20.9099 6.18608 20.8113 5.66937 20.564 5.18404C20.1805 4.43139 19.5686 3.81947 18.816 3.43598C18.3306 3.18868 17.8139 3.09012 17.2518 3.04419C16.7106 2.99998 16.0463 2.99999 15.2413 3H15C14.4477 3 14 3.44772 14 4C14 4.55229 14.4477 5 15 5H15.2C16.0566 5 16.6389 5.00078 17.089 5.03755C17.5274 5.07337 17.7516 5.1383 17.908 5.21799C18.2843 5.40973 18.5903 5.7157 18.782 6.09202C18.8617 6.24842 18.9266 6.47262 18.9624 6.91104C18.9992 7.36113 19 7.94342 19 8.8V9Z",
      fill: "#252833"
    })]
  }));
};

FullScreenIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var PercentIcon = function PercentIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M13.2552 0.585279C12.7505 0.328492 12.133 0.529696 11.8763 1.03465L4.2493 16.0359C3.99258 16.5408 4.19378 17.1581 4.69867 17.4148C4.84758 17.4905 5.00626 17.5263 5.16261 17.5263C5.53631 17.5263 5.89653 17.3214 6.07757 16.9654L13.7046 1.96417C13.9613 1.45928 13.7601 0.841997 13.2552 0.585279Z",
      fill: "#9A9EB3"
    }), /*#__PURE__*/_jsx("path", {
      d: "M7.77866 5.52514C7.77866 3.38054 6.03386 1.63574 3.88926 1.63574C1.74479 1.63574 0 3.38054 0 5.52514C0 7.66967 1.74479 9.41447 3.88933 9.41447C6.03393 9.41447 7.77866 7.66967 7.77866 5.52514ZM3.88933 7.36346C2.87572 7.36346 2.05101 6.53875 2.05101 5.52514C2.05101 4.51146 2.87572 3.68675 3.88933 3.68675C4.90301 3.68675 5.72772 4.51139 5.72772 5.52514C5.72765 6.53875 4.90301 7.36346 3.88933 7.36346Z",
      fill: "#9A9EB3"
    }), /*#__PURE__*/_jsx("path", {
      d: "M14.1106 8.58545C11.966 8.58545 10.2212 10.3302 10.2212 12.4748C10.2212 14.6193 11.9659 16.3641 14.1106 16.3641C16.2551 16.3641 17.9999 14.6194 17.9999 12.4748C17.9999 10.3302 16.2552 8.58545 14.1106 8.58545ZM14.1106 14.313C13.0969 14.313 12.2722 13.4883 12.2722 12.4747C12.2722 11.4611 13.0969 10.6364 14.1106 10.6364C15.1242 10.6364 15.9489 11.4611 15.9489 12.4747C15.9489 13.4883 15.1243 14.313 14.1106 14.313Z",
      fill: "#9A9EB3"
    })]
  }));
};

PercentIcon.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z",
      fill: "#D8DAE6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5Z",
      fill: "#696C80"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10Z",
      fill: "#696C80"
    })]
  }));
};

InfoIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const DEFAULT_FRAME_PERCENTAGE = 0.15;

const EditorFormFieldsChartBoundaries = _ref => {
  let {
    nameSpace,
    xScaleMin,
    xScaleDataMin,
    xScaleMinFramePercentage,
    xScaleMax,
    xScaleDataMax,
    xScaleMaxFramePercentage,
    yScaleMin,
    yScaleDataMin,
    yScaleMinFramePercentage,
    yScaleMax,
    yScaleDataMax,
    yScaleMaxFramePercentage,
    openButtonVariant,
    forceZeroBaseline,
    onChange
  } = _ref;
  const {
    0: updatedAt,
    1: setUpdatedAt
  } = useState(Date.now());
  const xScaleId = `${nameSpace}-x-scale`;
  const yScaleId = `${nameSpace}-y-scale`;
  const {
    0: activeTab,
    1: setActiveTab
  } = useState('framing');

  const handleDelete = () => {
    // Reset all values to null
    onChange({
      xScaleMin: null,
      xScaleMax: null,
      yScaleMin: null,
      yScaleMax: null,
      xScaleMinFramePercentage: null,
      xScaleMaxFramePercentage: null,
      yScaleMinFramePercentage: null,
      yScaleMaxFramePercentage: null
    });
    setUpdatedAt(Date.now());
  };

  const isModified = [xScaleMin, xScaleMax, yScaleMin, yScaleMax, xScaleMinFramePercentage, yScaleMinFramePercentage].some(value => typeof value !== 'undefined') || typeof xScaleMaxFramePercentage !== 'undefined' && xScaleMaxFramePercentage !== DEFAULT_FRAME_PERCENTAGE || typeof yScaleMaxFramePercentage !== 'undefined' && yScaleMaxFramePercentage !== DEFAULT_FRAME_PERCENTAGE;
  return /*#__PURE__*/_jsxs(RevealPill, {
    label: "Boundaries",
    activeState: /*#__PURE__*/_jsx(FullScreenIcon, {}),
    variant: isModified ? 'active' : '',
    openButtonVariant: openButtonVariant,
    noPadding: true,
    children: [/*#__PURE__*/_jsx("header", {
      className: styles.tabs,
      children: /*#__PURE__*/_jsxs(TabList, {
        variant: "secondary",
        children: [/*#__PURE__*/_jsx(TabItem, {
          name: "Framing",
          isActive: activeTab === 'framing',
          className: styles.tabItem,
          onClick: () => setActiveTab('framing')
        }), /*#__PURE__*/_jsx(TabItem, {
          name: "Limits",
          isActive: activeTab === 'limits',
          className: styles.tabItem,
          onClick: () => setActiveTab('limits')
        })]
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.menu,
      children: [activeTab === 'framing' ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("p", {
          className: styles.description,
          children: "Automatically adds whitespace to frame your largest and smallest data points in the chart."
        }), /*#__PURE__*/_jsx(ScaleFramingFields, {
          nameSpace: xScaleId,
          minLabel: "X Axis Left",
          maxLabel: "X Axis Right",
          minKey: "xScaleMinFramePercentage",
          maxKey: "xScaleMaxFramePercentage",
          minPercentage: xScaleMinFramePercentage,
          maxPercentage: xScaleMaxFramePercentage,
          onChange: onChange
        }), /*#__PURE__*/_jsx(ScaleFramingFields, {
          nameSpace: yScaleId,
          minLabel: "Y Axis Bottom",
          maxLabel: "Y Axis Top",
          minKey: "yScaleMinFramePercentage",
          maxKey: "yScaleMaxFramePercentage",
          minPercentage: yScaleMinFramePercentage,
          maxPercentage: yScaleMaxFramePercentage,
          onChange: onChange
        })]
      }) : /*#__PURE__*/_jsx(_Fragment, {}), activeTab === 'limits' ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(ScaleMinMaxFields, {
          scaleLabel: "X Axis",
          nameSpace: xScaleId,
          scaleMinKey: "xScaleMin",
          scaleMaxKey: "xScaleMax",
          scaleMin: xScaleMin,
          scaleDataMin: xScaleDataMin,
          scaleMax: xScaleMax,
          scaleDataMax: xScaleDataMax,
          forceZeroBaseline: forceZeroBaseline,
          onChange: onChange
        }), /*#__PURE__*/_jsx(ScaleMinMaxFields, {
          scaleLabel: "Y Axis",
          nameSpace: yScaleId,
          scaleMinKey: "yScaleMin",
          scaleMaxKey: "yScaleMax",
          scaleMin: yScaleMin,
          scaleDataMin: yScaleDataMin,
          scaleMax: yScaleMax,
          scaleDataMax: yScaleDataMax,
          forceZeroBaseline: forceZeroBaseline,
          onChange: onChange
        })]
      }) : /*#__PURE__*/_jsx(_Fragment, {}), isModified ? /*#__PURE__*/_jsx(Button, {
        type: "button",
        variant: "delete",
        className: styles.deleteButton,
        onClick: handleDelete,
        children: "Reset to default"
      }) : /*#__PURE__*/_jsx(_Fragment, {})]
    })]
  }, updatedAt);
};

const MIN_FRAME_PERCENTAGE = 0;
const MAX_FRAME_PERCENTAGE = 100;

const ScaleFramingFields = _ref2 => {
  let {
    nameSpace,
    minLabel,
    maxLabel,
    minKey = 'minFramePercentage',
    maxKey = 'maxFramePercentage',
    minPercentage,
    maxPercentage = DEFAULT_FRAME_PERCENTAGE,
    onChange
  } = _ref2;
  const scaleMinId = `${nameSpace}-min-percentage`;
  const scaleMaxId = `${nameSpace}-max-percentage`;
  return /*#__PURE__*/_jsxs("div", {
    className: parentStyles.formField__grid,
    children: [/*#__PURE__*/_jsx(Label, {
      forInput: scaleMinId,
      text: minLabel,
      className: parentStyles.formField,
      children: /*#__PURE__*/_jsx(Input, {
        id: scaleMinId,
        type: "number",
        placeholder: "0",
        min: MIN_FRAME_PERCENTAGE,
        max: MAX_FRAME_PERCENTAGE,
        rightIcon: /*#__PURE__*/_jsx(PercentIcon, {}),
        defaultValue: typeof minPercentage === 'number' ? minPercentage * 100 : undefined,
        onKeyDown: e => {
          if (!isValidNumberInputKey(e.key)) {
            e.preventDefault();
          }
        },
        onChange: evt => {
          onChange({
            [minKey]: getFramePercentage(evt.target.value)
          });
        }
      })
    }), /*#__PURE__*/_jsx(Label, {
      forInput: scaleMaxId,
      text: maxLabel,
      className: parentStyles.formField,
      icon: /*#__PURE__*/_jsx(Tooltip, {
        placement: "bottom",
        content: "Recommended 5 - 15%",
        children: /*#__PURE__*/_jsx(InfoIcon, {})
      }),
      children: /*#__PURE__*/_jsx(Input, {
        id: scaleMaxId,
        type: "number",
        placeholder: "100",
        min: MIN_FRAME_PERCENTAGE,
        max: MAX_FRAME_PERCENTAGE,
        rightIcon: /*#__PURE__*/_jsx(PercentIcon, {}),
        defaultValue: typeof maxPercentage === 'number' ? maxPercentage * 100 : undefined,
        onKeyDown: e => {
          if (!isValidNumberInputKey(e.key)) {
            e.preventDefault();
          }
        },
        onChange: evt => {
          onChange({
            [maxKey]: getFramePercentage(evt.target.value)
          });
        }
      })
    })]
  });
};

const getFramePercentage = value => {
  const update = parseInt(value, 10);
  if (isNaN(update)) return null;
  return Math.max(Math.min(update, MAX_FRAME_PERCENTAGE), MIN_FRAME_PERCENTAGE) / 100;
};

export default EditorFormFieldsChartBoundaries;